import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { NgIf, CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-currency-value-cell-rederer',
  templateUrl: './currency-value-cell-rederer.component.html',
  styleUrls: ['./currency-value-cell-rederer.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, CurrencyPipe]
})
export class CurrencyValueCellRedererComponent implements AfterViewInit {
  params: any;
  cellValue: any;
  email!: string | undefined;
  constructor() {}
  @ViewChild('content', { static: false }) container?: ElementRef;

  @ViewChild('trigger') button: any;

  ngAfterViewInit(): void {}

  agInit(params: any) {
    this.params = params;
    const valueToDisplay = this.getValueToDisplay(params);

    if (valueToDisplay != null && valueToDisplay !== '') {
      const sanitizedValue = parseFloat(valueToDisplay.replace(/[^\d.-]/g, ''));

      if (!isNaN(sanitizedValue)) {
        this.cellValue = sanitizedValue;
      } else {
        this.cellValue = 0;
      }
    } else {
      this.cellValue = 0;
    }
  }

  getValueToDisplay(params: ICellRendererParams): string | undefined {
    const formattedValue = params.valueFormatted ? params.valueFormatted : (params.value || '').toString();

    if (formattedValue !== undefined && formattedValue !== null) {
      return (formattedValue || '').toString();
    }

    return '';
  }
}
